import Title from "../Home/Components/Title/Title";
import useScrollToTop from "../../hooks/useScrollToTop";
import { useTranslation } from "../../i18n/LanguageProvider";
import LegalPage from "./Components/LegalPage";
import LegalSection from "./Components/LegalSection";
import "./Legal.sass";

function PrivacyPolicy() {
    const { t } = useTranslation();
    const sections = t("legal.privacySections") || [];

    useScrollToTop();

    return (
        <LegalPage title={<Title text={t("legal.privacyTitle")} />} updatedAt={t("legal.privacyUpdated")}>
            {sections.map((section) => (
                <LegalSection key={section.title} title={section.title}>
                    {(section.paragraphs || []).map((paragraph) => (
                        <p key={paragraph}>{paragraph}</p>
                    ))}
                    {section.list && (
                        <ul>
                            {section.list.map((item) => (
                                <li key={item}>{item}</li>
                            ))}
                        </ul>
                    )}
                </LegalSection>
            ))}
        </LegalPage>
    );
}

export default PrivacyPolicy;
